module.exports = __webpack_public_path__ + "img/billboard.14813810.png";